import space from '../namespace';
import defaultState, { IState } from '../state';
import actionTypes, { IAction, ActionTypeValues } from '../actionTypes';

const reducer = (
  state: IState,
  action: IAction<
    Partial<IState[space.home]> & {
      namespace?: `${space}`;
      resetKeys?: string[];
    }
  >,
): IState => {
  const { type, namespace = space.home, payload } = action;

  switch (type) {
    case actionTypes[namespace][ActionTypeValues.UPDATE_HOME_ARTICAL_LIST]: {
      const _state = state[namespace as space.home];
      return {
        ...state,
        [namespace]: {
          ..._state,
          articalList: { ...(_state?.articalList || {}), ...payload },
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_HOME_CHANNEL_LIST]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelList: payload
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_HOME_BANNER_LIST]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          bannerList: payload
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.RESET_PAGE_STATE]: {
      const { namespace: resetNameSpace = space.home, resetKeys = [] } = payload || {};
      const resetValues = resetKeys.reduce((prev, cur) => {
        const defaultValue = defaultState()[resetNameSpace] as any;
        return defaultValue
          ? { ...prev, [cur]: defaultValue[cur] }
          : { ...prev };
      }, {});
      return {
        ...state,
        [resetNameSpace]: {
          ...state[resetNameSpace],
          ...resetValues,
        },
      };
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_HOME_CHANNEL_ACTIVE_KEYS]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelActiveKeys: payload,
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_HOME_CHANNEL_SORT_KEY_MAP]: {
      const _state = state[namespace as space.home];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelSortKeyMap: { ...(_state?.channelSortKeyMap || {}), ...payload },
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_PC_HOME_ACTIVE_CHANNEL_NAME]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          pcActiveChannelName: payload
        }
      }
    }
    default:
      return state;
  }
};

export default reducer;
